"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierStatus = void 0;
const typeorm_1 = require("typeorm");
const class_transformer_1 = require("class-transformer");
// eslint-disable-next-line import/no-cycle
const Supplier_1 = require("./Supplier");
const CircularReference_1 = require("../../serialization/CircularReference");
const JournaledEntity_1 = require("../../JournaledEntity");
const SupplierStatusType_1 = require("./SupplierStatusType");
let SupplierStatus = class SupplierStatus extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierStatus = SupplierStatus;
__decorate([
    (0, typeorm_1.OneToOne)(() => Supplier_1.Supplier, (s) => s.status),
    (0, typeorm_1.JoinColumn)(),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Supplier_1.Supplier)
], SupplierStatus.prototype, "supplier", void 0);
__decorate([
    (0, typeorm_1.RelationId)((s) => s.supplier),
    __metadata("design:type", String)
], SupplierStatus.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => SupplierStatusType_1.SupplierStatusType),
    __metadata("design:type", SupplierStatusType_1.SupplierStatusType)
], SupplierStatus.prototype, "statusType", void 0);
__decorate([
    (0, typeorm_1.RelationId)((s) => s.statusType),
    __metadata("design:type", String)
], SupplierStatus.prototype, "statusTypeId", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'date', nullable: true }),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], SupplierStatus.prototype, "until", void 0);
__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    __metadata("design:type", String)
], SupplierStatus.prototype, "explanation", void 0);
exports.SupplierStatus = SupplierStatus = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], SupplierStatus);
